export default __webpack_public_path__ + "static/media/404-image.a856eb4b.png";